import { render, staticRenderFns } from "./ThirdPartyLiability.vue?vue&type=template&id=f868d140"
import script from "./ThirdPartyLiability.vue?vue&type=script&lang=js"
export * from "./ThirdPartyLiability.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports